<template>
  <div 
    class="ola-menu"
    :class="[
      `ola-menu-${mode}`,
      { 'ola-menu-collapse': collapse }
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'OlaMenu',
  props: {
    // 菜单模式：horizontal, vertical
    mode: {
      type: String,
      default: 'vertical',
      validator: (value) => {
        return ['horizontal', 'vertical'].includes(value);
      }
    },
    // 是否折叠（仅在 vertical 模式下有效）
    collapse: {
      type: Boolean,
      default: false
    },
    // 默认激活的菜单项
    defaultActive: {
      type: String,
      default: ''
    },
    // 默认打开的子菜单
    defaultOpeneds: {
      type: Array,
      default: () => []
    },
    // 菜单项的背景色
    backgroundColor: {
      type: String,
      default: ''
    },
    // 菜单项的文字颜色
    textColor: {
      type: String,
      default: ''
    },
    // 激活菜单项的文字颜色
    activeTextColor: {
      type: String,
      default: '#333'
    }
  },
  emits: ['select', 'open', 'close'],
  provide() {
    return {
      rootMenu: this
    };
  },
  data() {
    return {
      activeIndex: this.defaultActive,
      openedMenus: this.defaultOpeneds.slice(0),
      items: {},
      submenus: {}
    };
  },
  watch: {
    defaultActive(value) {
      this.activeIndex = value;
    },
    defaultOpeneds(value) {
      this.openedMenus = value.slice(0);
    }
  },
  methods: {
    addItem(item) {
      this.items[item.index] = item;
    },
    removeItem(item) {
      delete this.items[item.index];
    },
    addSubmenu(submenu) {
      this.submenus[submenu.index] = submenu;
    },
    removeSubmenu(submenu) {
      delete this.submenus[submenu.index];
    },
    selectItem(index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;
      this.$emit('select', index);
    },
    openMenu(index) {
      if (this.openedMenus.includes(index)) return;
      
      // 在水平模式下，同时只能打开一个子菜单
      if (this.mode === 'horizontal') {
        this.openedMenus = this.openedMenus.filter(
          indexPath => this.submenus[indexPath] && 
          !indexPath.startsWith(index) && 
          !index.startsWith(indexPath)
        );
      }
      
      this.openedMenus.push(index);
      this.$emit('open', index);
    },
    closeMenu(index) {
      const i = this.openedMenus.indexOf(index);
      if (i !== -1) {
        this.openedMenus.splice(i, 1);
        this.$emit('close', index);
      }
    }
  }
};
</script>

<style>
.ola-menu {
  list-style: none;
  position: relative;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.ola-menu-horizontal {
  display: flex;
  flex-wrap: nowrap;
  height: 62px;
}

.ola-menu-horizontal::after {
  content: "";
  display: table;
  clear: both;
}

.ola-menu-vertical {
  width: 100%;
  border-right: 1px solid #e6e6e6;
}

.ola-menu-collapse {
  width: 64px;
  overflow: hidden;
}

.ola-menu-collapse > .ola-menu-item [class^=ola-icon],
.ola-menu-collapse > .ola-submenu > .ola-submenu-title [class^=ola-icon] {
  margin: 0;
  vertical-align: middle;
  width: 24px;
  text-align: center;
}

.ola-menu-collapse > .ola-menu-item .ola-submenu-title-content,
.ola-menu-collapse > .ola-submenu > .ola-submenu-title .ola-submenu-title-content {
  display: none;
}

@media screen and (max-width: 768px) {
  .ola-menu-horizontal {
    flex-wrap: wrap;
    height: auto;
  }
}
</style> 